import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import EditDesignationApi from "../../../api/EditDesignationApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function EditDesignationModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    setValuesChanged(false);
    props.handleCancel();
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditDesignationApi(
      value.name,
      value.abbreviation,
      props.designation?.id
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Designation edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit designation. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit designation"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="editDesignation"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          name: props.designation?.name,
          abbreviation: props.designation?.abbreviation,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Designation name" name="name">
          <Input
            defaultValue={props.designation?.name}
            placeholder="Designation name"
          />
        </Form.Item>

        <Form.Item label="Abbreviation" name="abbreviation">
          <Input
            defaultValue={props.designation?.abbreviation}
            placeholder="Abb"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="btn w-40"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditDesignationModal;
